export default {
  path: '/ticket_statuses',
  name: 'ticket_statuses',
  component: () => import('../components/ticketstatus/Layout'),
  redirect: { name: 'TicketstatusList' },
  meta: {
    breadcrumb: 'ticket.ticketstatuses',
  },
  children: [
    {
      name: 'TicketstatusList',
      path: '',
      component: () => import('../views/ticketstatus/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'TicketstatusCreate',
      path: 'new',
      component: () => import('../views/ticketstatus/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'TicketstatusUpdate',
      path: ':id/edit',
      component: () => import('../views/ticketstatus/Update'),
      meta: {
        breadcrumb: 'ticket.ticketstatus',
      },
    },
    {
      name: 'TicketstatusShow',
      path: ':id',
      component: () => import('../views/ticketstatus/Show'),
      meta: {
        breadcrumb: 'ticket.ticketstatus',
      },
    }
  ]
};
